export default "__VITE_ASSET__DMPq2Jvk__"